import React from 'react';
import styled from 'styled-components';

// Low resolution login background gradient container
const LoginWrapperBackgroundContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(to right top, #096dd9, 70%, #00c2cc);
  position: fixed;
  top: 0;
  left: 0;
  isolation: isolate; /* Create new stacking context for filter */
`;

export const LoginBackgroundLowRes = () => <LoginWrapperBackgroundContainer data-testid="login-background-low-res" />;
